import { PdfDocumentType, PdfDocumentTypes } from '@zinnia/form-engine-sdk';
import { StoredFile, StoredFileDocType } from './../models';

export const PdfTypeToStoredFileDocTypeLookup: Record<PdfDocumentType, StoredFileDocType | undefined> = {
  [PdfDocumentTypes.application]: StoredFileDocType.ApplicationPdf,
  [PdfDocumentTypes.advisorsReport]: StoredFileDocType.AdvisorsReport,
  [PdfDocumentTypes.carrierReport]: StoredFileDocType.CarrierReport,
  [PdfDocumentTypes.external]: undefined,
  [PdfDocumentTypes.oneSpanEvidenceSummary]: undefined,
  [PdfDocumentTypes.medicalInterviewAnswers]: StoredFileDocType.MedicalInterviewAnswers,
};

export const StoredFileDocTypeToPdfTypeLookup: Record<StoredFileDocType, PdfDocumentType | undefined> = {
  [StoredFileDocType.ApplicationPdf]: PdfDocumentTypes.application,
  [StoredFileDocType.AdvisorsReport]: PdfDocumentTypes.advisorsReport,
  [StoredFileDocType.CarrierReport]: PdfDocumentTypes.carrierReport,
  [StoredFileDocType.Attachment]: undefined,
  [StoredFileDocType.Illustration]: undefined,
  [StoredFileDocType.OneSpanEvidenceSummary]: undefined,
  [StoredFileDocType.NeedsAnalysisPdf]: undefined,
  [StoredFileDocType.ApplicationMarketingDataExtractCSV]: undefined,
  [StoredFileDocType.SubmissionData]: undefined,
  [StoredFileDocType.MedicalInterviewAnswers]: PdfDocumentTypes.medicalInterviewAnswers,
};

export enum ESignDocumentStatus {
  /**
   * received request from Message Dispatcher
   */
  REQUESTED = 'REQUESTED',
  /**
   * PDF Generation in progress
   */
  GENERATING_PDF = 'GENERATING_PDF',
  /**
   * PDF Generated and uploaded
   */
  UPLOADED = 'UPLOADED',

  PDF_GENERATION_FAILED = 'PDF_GENERATION_FAILED',
}

export enum ESignDocumentType {
  GENERATED = 'GENERATED',
  UPLOADED = 'UPLOADED',
}

type BaseESignDocument = {
  id: string;
  ceremonyId: string;
  originalStoredFileId?: string;
  completedStoredFileId?: string;
  originalStoredFile?: StoredFile;
  completedStoredFile?: StoredFile;
  status: ESignDocumentStatus;
  type: ESignDocumentType;
  createdAt: Date;
  updatedAt: Date;
  participantId?: string;
};

export type ESignDocument = BaseESignDocument &
  (
    | {
        type: ESignDocumentType.GENERATED;
        status:
          | ESignDocumentStatus.GENERATING_PDF
          | ESignDocumentStatus.REQUESTED
          | ESignDocumentStatus.PDF_GENERATION_FAILED;
      }
    | {
        type: ESignDocumentType.UPLOADED | ESignDocumentType.GENERATED;
        status: ESignDocumentStatus.UPLOADED;
        fileTemplateId: string;
      }
  );

export type ESignDocumentWithOriginalStoredFile = ESignDocument & { originalStoredFile?: StoredFile };

export type ESignGeneratedDocument = StoredFileDocType.AdvisorsReport | StoredFileDocType.ApplicationPdf;
export type ESignUploadedDocument = StoredFileDocType.Illustration | StoredFileDocType.Attachment;

export const generatedDocuments: ESignGeneratedDocument[] = [
  StoredFileDocType.AdvisorsReport,
  StoredFileDocType.ApplicationPdf,
];
export const uploadedDocuments: ESignUploadedDocument[] = [
  StoredFileDocType.Illustration,
  StoredFileDocType.Attachment,
];

export type LocalizedESignDocumentInfo = { name: string; description: string };
